<template>
  <div class="container pl-0 pt-0 pr-0 pb-0">
    <div v-if="isLoadingBooking">
      <v-skeleton-loader
        v-for="i in 4"
        :key="i"
        width="100%"
        type="heading, list-item"
      />
    </div>
    <div v-else-if="booking">
      <h2 class="mb-3">Role</h2>
      <Permissioned section="bookings" vertical :id="bookingId">
        <LabeledText label="Job Title" permission="view.role-title">
          {{ booking.title }}
        </LabeledText>
        <LabeledText permission="view.grade" label="Grade">
          {{ booking.grade || "-" }}
        </LabeledText>
        <LabeledText label="Contract Type & Working Hours">
          <v-chip permission="view.contract-type" label class="mr-2">
            {{ booking.contractType }}
          </v-chip>
          <v-chip permission="view.working-hours" label>
            {{ booking.workingHours || "-" }}
          </v-chip>
        </LabeledText>
        <LabeledText label="Location" permission="view.location">
          {{ booking.location.line1 }}, {{ booking.location.line2 }},
          {{ booking.location.line3 }}
        </LabeledText>
        <LabeledText label="Cost Centre" permission="view.cost-centre">
          {{ costCentre }}
        </LabeledText>
      </Permissioned>
    </div>
  </div>
</template>

<script>
import Permissioned from "@/components/common/Permissioned";
import LabeledText from "@/components/common/BaseDetails/LabeledText";
import {
  FETCH_CURRENT_BOOKING,
  BOOKINGS_NAMESPACE
} from "@/store/modules/bookings/actions";
import {
  GET_CURRENT_BOOKING,
  IS_LOADING_BOOKING
} from "@/store/modules/bookings/getters";
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapGetters } = createNamespacedHelpers(BOOKINGS_NAMESPACE);

export default {
  props: {
    bookingId: String
  },
  components: {
    Permissioned,
    LabeledText
  },
  created() {
    this.fetchCurrentBooking(this.bookingId);
  },
  computed: {
    ...mapGetters({
      booking: GET_CURRENT_BOOKING,
      isLoadingBooking: IS_LOADING_BOOKING
    }),
    costCentre() {
      return this.booking.client ? `${this.booking.client.name}` : "-";
    }
  },
  methods: {
    ...mapActions({
      fetchCurrentBooking: FETCH_CURRENT_BOOKING
    })
  }
};
</script>

<style lang="scss" scoped></style>
